/** ATS applications attached to a June person (one row can hold several). */

export function isSafeExternalUrl(value) {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  const lower = trimmed.toLowerCase();
  return lower.startsWith("http://") || lower.startsWith("https://");
}

export function listAtsApplications(applicant) {
  const activeId = applicant?.ats_application_id;
  const rows = Array.isArray(applicant?.ats_applications)
    ? applicant.ats_applications
    : [];
  const mapped = rows.map((row) => ({
    id: row.id,
    ats_application_id: row.ats_application_id,
    ats_current_stage_name: row.ats_current_stage_name,
    is_declined: Boolean(row.is_declined),
    created_at: row.created_at,
    is_active: Boolean(activeId) && row.ats_application_id === activeId,
  }));
  if (mapped.length === 0 && activeId) {
    mapped.push({
      id: null,
      ats_application_id: activeId,
      ats_current_stage_name: applicant.ats_current_stage_name,
      is_declined: applicant.status === "ATS_DECLINED",
      created_at: applicant.created_at,
      is_active: true,
    });
  }
  return mapped.sort((a, b) => {
    if (a.is_active !== b.is_active) return a.is_active ? -1 : 1;
    return String(b.created_at || "").localeCompare(String(a.created_at || ""));
  });
}

export function atsApplicationCount(applicant) {
  return listAtsApplications(applicant).length;
}

export function toAnalysisApplicant(applicant) {
  if (!applicant) return null;
  return {
    id: applicant?.id,
    name: applicant?.name,
    phone: applicant?.phone_number,
    status: applicant?.interview_session?.status,
    analysis_status: applicant?.interview_session?.analysis_status,
    calendar_link_sent_at: applicant?.interview_session?.calendar_link_sent_at,
    created_at: applicant?.interview_session?.created_at,
    updated_at: applicant?.interview_session?.updated_at,
    ai_insights: applicant?.interview_session?.ai_insights,
    interview_session_id:
      applicant?.interview_session?.id || applicant?.interview_session_id,
    interview_responses: applicant?.interview_session?.interview_responses || [],
    // OutdatedQuestionsBadge reads the frozen question set off the session.
    interview_session: applicant?.interview_session,
    is_closed: applicant?.interview_session?.is_closed,
    job: applicant?.job,
    ats_application_id: applicant?.ats_application_id,
    ats_current_stage_name: applicant?.ats_current_stage_name,
    ats_applications: applicant?.ats_applications || [],
    ats_profile_url: applicant?.ats_profile_url,
  };
}
